<template>
    <div>
        <b-card class="bg-default-card no-padding" v-if="project && trajectory">
            <b-tabs card v-model="trajectoryShowTabState">
                <b-tab :title="uLang('app.entity_details', { entity: lang('app.trajectory') })" active>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="inner">
                                <div class="mb-3">
                                    <router-link class="btn btn-brand" :to="{ name: 'admin.trajectory_projects.trajectories.edit', params: { projectId: this.projectId, id: this.id } }">{{ uLang('app.edit_type', { type: lang('app.trajectory') }) }}</router-link>
                                    <a class="btn btn-brand" href="#" @click.prevent="duplicate">{{ uLang('app.duplicate_type', { type: lang('app.trajectory') }) }}</a>
                                </div>

                                <table class="table">
                                    <tr>
                                        <td width="200">{{ uLang('app.project_name') }}:</td>
                                        <td>
                                            <router-link :to="{ name: 'admin.trajectory_projects.view', params: { id: project.id }}">
                                                {{ project.name }}
                                            </router-link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.name') }}:</td>
                                        <td>{{ trajectory.name }}</td>
                                    </tr>
                                    <tr v-if="trajectory.description">
                                        <td width="200">{{ uLang('app.description') }}:</td>
                                        <td>{{ trajectory.description }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.trajectory_type') }}:</td>
                                        <td><b-badge v-if="trajectory.trajectory_type" pill variant="primary">{{ trajectory.trajectory_type.value }}</b-badge></td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.trajectory_managers') }}:</td>
                                        <td>
                                            <b-badge v-for="trajectory_manager of trajectory.trajectory_managers" :key="trajectory_manager.id" pill variant="primary">
                                                <router-link :to="{ name: 'admin.relations.view', params: { id: trajectory_manager.id }}">
                                                    {{ trajectory_manager.full_name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.trajectory_inspectors') }}:</td>
                                        <td>
                                            <b-badge v-for="trajectory_inspector of trajectory.trajectory_inspectors" :key="trajectory_inspector.id" pill variant="primary">
                                                <router-link :to="{ name: 'admin.relations.view', params: { id: trajectory_inspector.id }}">
                                                    {{ trajectory_inspector.full_name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.casemanagers') }}:</td>
                                        <td>
                                            <b-badge v-for="casemanager of trajectory.casemanagers" :key="casemanager.id" pill variant="primary">
                                                <router-link :to="{ name: 'admin.relations.view', params: { id: casemanager.id }}">
                                                    {{ casemanager.full_name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.reporting_person') }}:</td>
                                        <td>
                                            <b-badge pill variant="primary" v-if="trajectory.reporting_person">
                                                <router-link :to="{ name: 'admin.relations.view',
                                                    params: { id: trajectory.reporting_person.id }
                                                }">
                                                    {{ trajectory.reporting_person.full_name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.trajectory_administrators') }}:</td>
                                        <td>
                                            <b-badge v-for="trajectory_administrator of trajectory.trajectory_administrators" :key="trajectory_administrator.id" pill variant="primary">
                                                <router-link :to="{ name: 'admin.relations.view', params: { id: trajectory_administrator.id }}">
                                                    {{ trajectory_administrator.full_name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.amount_of_candidates') }}:</td>
                                        <td>
                                            <a href="#" @click.prevent="loadCandidatesModal(trajectory)" v-if="trajectory.enrolment_count">{{ trajectory.enrolment_count }}</a>
                                            <span v-if="!trajectory.enrolment_count">{{ trajectory.enrolment_count }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.amount_of_active_candidates') }}:</td>
                                        <td>
                                            <a href="#" @click.prevent="loadCandidatesModal(trajectory, 'active')" v-if="trajectory.active_enrolment_count">{{ trajectory.active_enrolment_count }}</a>
                                            <span v-if="!trajectory.active_enrolment_count">{{ trajectory.active_enrolment_count }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.amount_of_completed_candidates') }}:</td>
                                        <td>
                                            <a href="#" @click.prevent="loadCandidatesModal(trajectory, 'completed')" v-if="trajectory.completed_enrolment_count">{{ trajectory.completed_enrolment_count }}</a>
                                            <span v-if="!trajectory.completed_enrolment_count">{{ trajectory.completed_enrolment_count }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.amount_of_successful_completions') }}:</td>
                                        <td>
                                            <a href="#" @click.prevent="loadCandidatesModal(trajectory, 'completed_successful')" v-if="trajectory.completed_successfully_enrolment_count">{{ trajectory.completed_successfully_enrolment_count }}</a>
                                            <span v-if="!trajectory.completed_successfully_enrolment_count">{{ trajectory.completed_successfully_enrolment_count }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.amount_of_unsuccessful_completions') }}:</td>
                                        <td>
                                            <a href="#" @click.prevent="loadCandidatesModal(trajectory, 'completed_unsuccessful')" v-if="trajectory.completed_unsuccessfully_enrolment_count">{{ trajectory.completed_unsuccessfully_enrolment_count }}</a>
                                            <span v-if="!trajectory.completed_unsuccessfully_enrolment_count">{{ trajectory.completed_unsuccessfully_enrolment_count }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.amount_of_completions_at_the_expense_of_the_client') }}:</td>
                                        <td>
                                            <a href="#" @click.prevent="loadCandidatesModal(trajectory, 'completed_at_the_expense_of_the_client')" v-if="trajectory.completed_at_the_expense_of_the_client_enrolment_count">{{ trajectory.completed_at_the_expense_of_the_client_enrolment_count }}</a>
                                            <span v-if="!trajectory.completed_at_the_expense_of_the_client_enrolment_count">{{ trajectory.completed_at_the_expense_of_the_client_enrolment_count }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.amount_of_canceled_candidates') }}:</td>
                                        <td>
                                            <a href="#" @click.prevent="loadCandidatesModal(trajectory, 'canceled')" v-if="trajectory.canceled_enrolment_count">{{ trajectory.canceled_enrolment_count }}</a>
                                            <span v-if="!trajectory.canceled_enrolment_count">{{ trajectory.canceled_enrolment_count }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.minimum_success_rate') }}:</td>
                                        <td>{{ trajectory.minimum_success_rate ? trajectory.minimum_success_rate + '%' : '' }}</td>
                                    </tr>
                                    <tr v-if="trajectory.maximum_hours">
                                        <td width="200">{{ uLang('app.maximum_hours') }}:</td>
                                        <td>{{ trajectory.maximum_hours }}</td>
                                    </tr>
                                    <tr v-if="trajectory.lead_time_in_days">
                                        <td width="200">{{ uLang('app.lead_time_in_days') }}:</td>
                                        <td>{{ trajectory.lead_time_in_days }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.email_template') }}:</td>
                                        <td><b-badge v-if="trajectory.email_template" pill variant="primary">{{ trajectory.email_template.name }}</b-badge></td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.service_according_to_blik_op_werk') }}:</td>
                                        <td><b-badge v-if="trajectory.blik_op_werk" pill variant="primary">{{ trajectory.blik_op_werk.value }}</b-badge></td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.fact_sheet') }}:</td>
                                        <td>
                                            <download-file-link v-if="trajectory.fact_sheet" :name="trajectory.fact_sheet.name" :file-id="trajectory.fact_sheet.id"></download-file-link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.variable_trajectory_prices') }}:</td>
                                        <td><b-badge pill variant="primary">{{ uLang('app.' + (trajectory.variable_trajectory_prices ? 'yes' : 'no')) }}</b-badge></td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.active') }}:</td>
                                        <td><b-badge pill variant="primary">{{ uLang('app.' + (trajectory.active ? 'yes' : 'no')) }}</b-badge></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab :title="uLang('app.milestones')">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="pull-right mb-3">
                                <router-link class="btn btn-brand" :to="{ name: 'admin.trajectory_projects.trajectories.milestones.create', params: { projectId: this.projectId, trajectoryId: this.id } }">{{ uLang('app.add_type', { type: lang('app.milestone') }) }}</router-link>
                            </div>

                            <milestone-table :url="route('trajectory-projects.trajectories.milestones.table', { trajectory_project: this.projectId, trajectory: this.id })"/>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>

        <relation-trajectory-enrolments-modal ref="modal"/>
    </div>
</template>

<script>
    import RelationTrajectoryEnrolmentsModal from '~/components/modals/relation-trajectory-enrolments'
    import MilestoneTable from '~/components/tables/admin/projects/milestone/table'
    import MilestoneForm from '~/components/forms/admin/projects/milestone/form'

    export default {
        name: 'show',
        props: {
            projectId: {
                required: true,
            },
            id: {
                required: true,
            },
        },

        components: {
            'milestone-form': MilestoneForm,
            'milestone-table': MilestoneTable,
            'relation-trajectory-enrolments-modal': RelationTrajectoryEnrolmentsModal,
        },

        data() {
            return {
                project: undefined,
                trajectory: undefined,
            }
        },

        created() {
            this.retrieveProject();
            this.retrieveTrajectory();
        },

        methods: {
            async retrieveProject() {
                const {data} = await window.axios.get(route('trajectory-projects.show', { trajectory_project: this.projectId }));
                this.project = data;
            },

            async retrieveTrajectory() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.show', { trajectory_project: this.projectId, trajectory: this.id }));
                this.trajectory = data;
            },

            edit() {
                this.$router.push({ name: 'admin.trajectory_projects.trajectories.edit', params: { projectId: this.projectId, id: this.id } });
            },

            async duplicate() {
                let {data} = await window.axios.post(route('trajectory-projects.trajectories.duplicate', { trajectory_project: this.projectId, trajectory: this.id }));

                this.$router.push({ name: 'admin.trajectory_projects.trajectories.edit', params: { trajectory_project: this.projectId, id: data.id }});
            },

            loadCandidatesModal(trajectory, status) {
                this.$store.dispatch('retrieveEnrolments', {
                    trajectory_project_id: trajectory.trajectory_project_id,
                    trajectory_id: trajectory.id,
                    status: status
                });

                this.$refs.modal.$refs.modal.show();
            },
        },

        computed: {
            overrideEndpoint() {
                return route('trajectory-projects.trajectories.milestones.store', { trajectory_project: this.projectId, trajectory: this.id })
            },
            trajectoryShowTabState: {
                get () { return this.$store.getters.tabState('trajectory-show') },
                set (v) { this.$store.commit('SET_TAB_STATE', { name: 'trajectory-show', value: v }) }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .card-block {
        padding: 0 !important;
    }
    .badge.badge-primary.badge-pill {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;

        margin-right: 2px;
        margin-bottom: 2px;
    }
</style>
